import { twMerge } from 'tailwind-merge';

import { Skeleton } from '@/_components';

import type { LoaderProps } from './types';

export function Loader({ withLabel, height, className }: LoaderProps) {
  return (
    <article className={twMerge('flex flex-col gap-2', className)}>
      {withLabel && <Skeleton className="h-[17.5px] w-32" />}
      <div
        style={{ height, minHeight: height, maxHeight: height }}
        className="border-c-border bg-background-paper overflow-hidden rounded-xl border border-solid"
      >
        <section className="border-c-border bg-grey-50 flex h-[41px] items-center gap-x-4 border-0 border-b border-solid px-2 py-0">
          <div>
            <Skeleton className="size-6" />
          </div>
          <div>
            <Skeleton className="size-6" />
          </div>
          <div>
            <Skeleton className="size-6" />
          </div>
          <div>
            <Skeleton className="size-6" />
          </div>
          <div>
            <Skeleton className="size-6" />
          </div>
          <div>
            <Skeleton className="size-6" />
          </div>
          <div>
            <Skeleton className="size-6" />
          </div>
          <div>
            <Skeleton className="size-6" />
          </div>
          <div>
            <Skeleton className="size-6" />
          </div>
          <div>
            <Skeleton className="size-6" />
          </div>
          <div>
            <Skeleton className="size-6" />
          </div>
        </section>
        <section className="flex flex-col gap-4 pt-8 pr-2 pb-2 pl-4">
          <div>
            <Skeleton className="h-4 w-4/5" />
          </div>
          <div>
            <Skeleton className="h-4 w-4/5" />
          </div>
          <div>
            <Skeleton className="h-4 w-4/5" />
          </div>
          <div>
            <Skeleton className="h-4 w-4/5" />
          </div>
          <div>
            <Skeleton className="mb-4 h-4 w-2/3" />
          </div>
        </section>
      </div>
    </article>
  );
}
